// You can pass some outer data here
export default () => {
  return [
    {
      prop: 'id',
      label: '编号',
      width: 80
    },
    {
      prop: 'name',
      label: '规格名称',
    },
    {
      prop: 'property_values',
      label: '规格值',
      width: 200,
      type: 'expand',
      renderCell(h, { row }) {
        const properties = row.property_values || [];
        return <div class="flex wrap">{properties.map(item => <el-tag style="margin-bottom: 10px; margin-right: 10px;">{item.value}</el-tag>)}</div>
      },
    },
    {
      prop: 'created_at',
      label: '创建时间',
      renderCell: 'time',
      width: 160
    },
    {
      prop: 'action',
      label: '操作',
      detail: true,
      edit: ({ row }) => {
        if (row.name === '颜色') { return false }
        return true;
      },
    }
  ];
}
